import { decamelizeKeys } from 'humps';
import { ISelectOption } from '@whitelabel/helpers/types';
import { getCurrencySymbolOrName } from '@whitelabel/helpers/utils';
import { dateDDMMYYYYtoISO } from '../date';
import { ILabelValuePair } from '../types';

export const countriesToSelectOptions = (
  countries: Record<string, { code: string; name: string }>,
  locale?: string | string[],
): ILabelValuePair[] =>
  Object.values(countries)
    .map(({ code, name }) => ({ value: code, label: name }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));

export const convertObjectNullToString = (values: any) => {
  Object.keys(values).forEach((key) => {
    if (values[key] === null) {
      values[key] = '';
    }
  });
  return values;
};

export const convertEmptyStringToNull = (values: any) => {
  Object.keys(values).forEach((key) => {
    if (values[key] === '') {
      values[key] = null;
    }
  });
  return values;
};
// Returns a new customer object ready to be used in an API request
export const customerFormToAPI = ({ birthDate, ...attributes }: any) =>
  decamelizeKeys({
    ...attributes,
    birthDate: birthDate ? dateDDMMYYYYtoISO(birthDate) : null,
  });

export const currenciesToSelectOptions = (locale: string, currencies: ISelectOption[]): ISelectOption[] =>
  Object.values(currencies).sort((a, b) =>
    getCurrencySymbolOrName(locale, a.value!, false).localeCompare(getCurrencySymbolOrName(locale, b.value!, false)),
  );
